import React from 'react';
import avikaLogo from '../assets/avika-logo.png';

interface AvikaLogoProps {
  height?: number;
  variant?: 'dark' | 'light';
  markOnly?: boolean;
  className?: string;
}

export const AvikaLogo: React.FC<AvikaLogoProps> = ({
  height = 80,
  variant = 'dark',
  markOnly = false,
  className = '',
}) => {
  const pad = Math.max(5, Math.round(height * 0.1));

  if (variant === 'light') {
    return (
      <div
        className={className}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255,255,255,0.97)',
          borderRadius: Math.round(height * 0.15),
          padding: pad,
        }}
      >
        <img
          src={avikaLogo}
          alt="Avika"
          style={{ height, width: 'auto', display: 'block' }}
          draggable={false}
        />
      </div>
    );
  }

  return (
    <img
      src={avikaLogo}
      alt="Avika"
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      draggable={false}
    />
  );
};

export default AvikaLogo;
